import { render, staticRenderFns } from "./yearSelectModel.vue?vue&type=template&id=a8b2739a&lang=html"
import script from "./yearSelectModel.vue?vue&type=script&lang=js"
export * from "./yearSelectModel.vue?vue&type=script&lang=js"
import style0 from "./yearSelectModel.vue?vue&type=style&index=0&id=a8b2739a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports